module.exports = __webpack_public_path__ + "static/media/omdb-movies-search-movie-desktop.315ef47e.jpg";